<template>
  <div id="login">
    <PasswordReset v-if="showPasswordReset" @close="togglePasswordReset()"></PasswordReset>
    <section>
      <div class="col1">
        <router-link to="/"></router-link>
      </div>
      <div class="col2">
        <form @submit.prevent>
          <h1>Log in</h1>
          <div>
            <label for="email1">Email</label>
            <input v-model.trim="loginForm.email" type="text" placeholder="you@email.com" id="email1" />
          </div>
          <div>
            <label for="password1">Password</label>
            <input v-model.trim="loginForm.password" type="password" id="password1" />
          </div>
          <button @click="login" class="button" :disabled="pending" v-html="pending ? 'Logging in...' : 'Log in'" />
          <div class="extras">
            <a @click="togglePasswordReset">Forgot Password</a>
            <router-link to="/packages">Create an Account</router-link>
          </div>
          <div class="error-msg" v-html="`Error: ${errorMsg}`" v-if="errorMsg" />
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import PasswordReset from '@/components/PasswordReset'

export default {
  components: {
    PasswordReset
  },
  data() {
    return {
      errorMsg: '',
      loginForm: {
        email: '',
        password: ''
      },
      pending: false,
      showPasswordReset: false
    }
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset
    },
    login() {
      this.pending = true
      this.$store.dispatch('login', {
        email: this.loginForm.email,
        password: this.loginForm.password
      }).then(() => {
        this.$router.push('/dashboard')
      }, error => {
        this.errorMsg = error.message
        this.pending = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
// login
#login {
  background: linear-gradient(0deg, #0e5c94 0%, #0e5c94 50%, #fff 51%, #fff 100%);

  @media ($sm-down) {
    // background: linear-gradient(to bottom, $primary 0%, darken($primary, 3) 35%, $white 35%, $white 100%);
    height: 100vh;
  }

  .col1,
  .col2 {
    height: 100vh;
    padding-top: 30vh;
    flex-basis: 50%;
    padding: 15vh 5% 5%;
    @media ($sm-down) {
      height: auto;
      padding: 5% 5% 10%;
      justify-content: center;
    }
  }

  .col1 {
    padding-left: 2rem;
    color: $white;
    background-color: $primary;
    text-align: center;
    max-width: 500px;
    @media ($md-down) {
      max-width: 37vw;
      padding-right: 8vw;
    }
    @media ($sm-up) {
      padding-top: 15vh;
    }
    @media ($sm-down) {
      display: flex;
      justify-content: center;
      align-items: center;;
      max-width: 100vw;
      margin-right: 0;
    }

    // Logo
    a {
      @media($sm-up) {
        top: -16px;
        position: relative;
      }
      @include logo;
      &::before {
        margin: 0 auto;
      }
    }

    p {
      max-width: 490px;
      margin-top: 2rem;
      line-height: 1.8;
    }

    a {
      color: $white;
      text-decoration: underline;
    }

    h6 {
      margin: 0;
      font-size: .75rem;
    }
  }

  .signup-form {
    @media ($sm-down) {
      padding-top: 10vh;
    }
  }

  .col2 {
    background-color: white;
    @media ($sm-up) {
      border-bottom-left-radius: 200px;
    }
    h1 {
      margin-bottom: 2rem;
    }

    form {
      max-width: 450px;
      margin: 0 auto;
    }

    .extras {
      float: right;
      text-align: right;

      a {
        display: block;
        margin-bottom: 0.5rem;
      }
    }

    .password-reset {
      h1 {
        margin-bottom: 1rem;
      }

      p {
        margin-bottom: 2rem;
      }
    }
  }
}
</style>
